import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@/utils/style.ts";

export function DiagnosticsList({ className, ...props }: ComponentPropsWithoutRef<"ul">) {
    return <ul className={cn("diagnostics-list", className)} {...props} />;
}